/**
 * Per-admin notification preferences (localStorage, keyed by admin id).
 */
import { isAdminChatOpen } from "./openAdminChatIds";

const STORAGE_PREFIX = "naseebi_admin_notify_prefs_";

export const DEFAULT_ADMIN_NOTIFY_PREFS = {
  enabled: true,
  browser: true,
  toast: true,
  types: {
    support_ticket: true,
    user_registered: true,
    verification_pending: true,
    chat_message: true,
    user_online: true,
  },
};

function cloneDefaults() {
  return {
    ...DEFAULT_ADMIN_NOTIFY_PREFS,
    types: { ...DEFAULT_ADMIN_NOTIFY_PREFS.types },
  };
}

function storageKey(adminId) {
  return `${STORAGE_PREFIX}${adminId || "anon"}`;
}

export function getPrefs(adminId) {
  try {
    const raw = localStorage.getItem(storageKey(adminId));
    if (!raw) return cloneDefaults();
    const parsed = JSON.parse(raw);
    return {
      enabled: parsed.enabled !== false,
      browser: parsed.browser !== false,
      toast: parsed.toast !== false,
      types: {
        ...DEFAULT_ADMIN_NOTIFY_PREFS.types,
        ...(parsed.types && typeof parsed.types === "object" ? parsed.types : {}),
      },
    };
  } catch {
    return cloneDefaults();
  }
}

export function setPrefs(adminId, patch = {}) {
  const current = getPrefs(adminId);
  const next = {
    enabled: patch.enabled != null ? !!patch.enabled : current.enabled,
    browser: patch.browser != null ? !!patch.browser : current.browser,
    toast: patch.toast != null ? !!patch.toast : current.toast,
    types: {
      ...current.types,
      ...(patch.types && typeof patch.types === "object" ? patch.types : {}),
    },
  };
  try {
    localStorage.setItem(storageKey(adminId), JSON.stringify(next));
  } catch {
    // ignore quota
  }
  return next;
}

export function isAlertAllowed(prefs, alertType) {
  if (!prefs || prefs.enabled === false) return false;
  if (!alertType) return true;
  const types = prefs.types || {};
  if (Object.prototype.hasOwnProperty.call(types, alertType)) {
    return types[alertType] !== false;
  }
  return true;
}

export function isChatAlreadyOpen(alert) {
  if (typeof window === "undefined") return false;
  const openTicketId = window.__naseebiOpenTicketId;
  const meta = alert?.meta || {};
  if (isAdminChatOpen(meta.chatId)) {
    return true;
  }
  if (
    openTicketId != null &&
    meta.ticketId != null &&
    String(openTicketId) === String(meta.ticketId)
  ) {
    return true;
  }
  if (
    openTicketId != null &&
    alert?.type === "chat_message" &&
    alert?.refId != null &&
    String(openTicketId) === String(alert.refId) &&
    (meta.channel === "support" || meta.ticketId != null)
  ) {
    return true;
  }
  return false;
}
